import { Calendar, Video } from "lucide-react";

export const formatTime = (dateString) =>
  dateString ? new Date(dateString).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true }) : "";

export const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  if (date.toDateString() === today.toDateString()) return "Today";
  if (date.toDateString() === tomorrow.toDateString()) return "Tomorrow";
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

export const getTimeUntilMeeting = (startTime) => {
  if (!startTime) return "";
  const diffMs = new Date(startTime) - new Date();
  if (diffMs < 0) return "Started";
  const diffMins = Math.floor(diffMs / 60000);
  if (diffMins < 60) return `in ${diffMins}m`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `in ${diffHours}h`;
  return formatDate(startTime);
};

export const isStartingSoon = (startTime) => {
  const diffMs = new Date(startTime) - new Date();
  return diffMs >= 0 && diffMs <= 15 * 60000;
};

const VIDEO_SOURCES = new Set(["zoom", "google", "outlook"]);

export const MeetingTypeIcon = ({ source }) =>
  VIDEO_SOURCES.has(source) ? <Video className="h-4 w-4 text-ism-teal" /> : <Calendar className="h-4 w-4 text-gray-400" />;

export const openExternal = (url) => window.open(url, "_blank");
